import ListView from './ListView.vue';
import ShowView from './ShowView.vue';
import AddView from './AddView.vue';

export default {
    ListView,
    ShowView,
    AddView
};